import Component from "@ember/component"
import { action, computed, get, set } from "@ember/object"
import { inject as service } from "@ember/service"
import _ from "lodash"

export default class CourseTimeline extends Component {
  @service("dispatcher")
  dispatcher

  showDatesLessonsUnits = true

  // didInsertElement(){
  //   Ember.run.scheduleOnce('afterRender', () => {
  //     if (get(this, "showDatesLessonsUnits") !== true) set(this, 'showDatesLessonsUnits', true);
  //   })
  // },

  @computed("dates", "course.attributes.calendar.datesOff")
  get datesWithOff() {
    let datesOff = get(this, "course.attributes.calendar.datesOff")
    let datesOffDictionary = _.reduce(
      datesOff,
      (acc, dateOff) => {
        acc[dateOff] = true
        return acc
      },
      {}
    )

    let customDates = _.filter(this.course.attributes.calendar.dates, {
      type: "course-date-custom",
    })
    return _.map(get(this, "dates"), (date, index) => {
      let courseDate = _.find(customDates, (cd) => {
        return cd.attributes.dateString === date.dateString
      })
      let isForcedOn = courseDate && courseDate.attributes.isForcedOn === true
      let isOff =
        isForcedOn !== true &&
        (datesOffDictionary[`${date.semesterId}:${date.rotationId}`] ||
          datesOffDictionary[date.dateString])

      return Object.assign({}, date, { isOff: isOff || false, index: index })
    })
  }

  @action
  openOutlineModal(courseId) {
    get(this, "dispatcher").dispatch("OPEN_COURSE_OUTLINE_MODAL", {
      sessionId: get(this, "appState.id"),
      componentId: "course-outline-modal",
      courseId: courseId,
      // focusedItemId: "2015-09-02"
      focusedItemId: get(this, "selectedDate"),
    })
  }

  // Show/Hide units
  @action
  showAddingUnits(courseId) {
    set(this, "isAddingUnits", true)
  }

  @action
  cancelAddingUnits() {
    set(this, "isAddingUnits", false)
  }

  // Show/Hide lessons
  @action
  showAddingLessons(courseId) {
    set(this, "isAddingLessons", true)
  }

  @action
  cancelAddingLessons() {
    set(this, "isAddingLessons", false)
  }

  @action
  onHighlightDates(dates) {
    this.highlightDates(dates)
  }

  @action
  onHideCourseTitleBanner(val) {
    this.hideCourseTitleBanner(val)
  }
}
